import React from "react";
import "./style.css";

const mockData = [
  {
    id: "1",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    spotId: 1,
    status: "available",
    consumption: 0,
    reading: 1245.6,
  },
  {
    id: "2",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    spotId: 2,
    status: "charging",
    consumption: 32.4,
    reading: 2156.8,
  },
  {
    id: "3",
    building: 'ТЦ "Мега"',
    serial: "EVSE-MEG-2024-003",
    spotId: 1,
    status: "occupied",
    consumption: 12.1,
    reading: 892.3,
  },
];

const statusConfig = {
  available: { label: "Свободно", color: "#10b981", bg: "#d1fae5" },
  charging: { label: "Зарядка", color: "#3b82f6", bg: "#dbeafe" },
  occupied: { label: "Занято", color: "#f59e0b", bg: "#fef3c7" },
  completed: { label: "Готово", color: "#8b5cf6", bg: "#ede9fe" },
  error: { label: "Ошибка", color: "#ef4444", bg: "#fee2e2" },
};

const DemoUsersV2 = () => {
  return (
    <div className="v2-wrapper">
      {/* Шапка */}
      <header className="v2-header">
        <h1 className="v2-title">Мои станции</h1>
        <div className="v2-avatar">АК</div>
      </header>

      {/* Счётчик */}
      <div className="v2-stats">
        <div className="v2-stat">
          <span className="v2-stat-value">3</span>
          <span className="v2-stat-label">всего</span>
        </div>
        <div className="v2-stat">
          <span className="v2-stat-value v2-stat-active">1</span>
          <span className="v2-stat-label">зарядка</span>
        </div>
      </div>

      {/* Список */}
      <div className="v2-list">
        {mockData.map((item) => {
          const st = statusConfig[item.status] || statusConfig.available;
          return (
            <div key={item.id} className="v2-card">
              <div className="v2-card-top">
                <span
                  className="v2-badge"
                  style={{ color: st.color, background: st.bg }}
                >
                  {st.label}
                </span>
                <span className="v2-spot">Место #{item.spotId}</span>
              </div>

              <div className="v2-card-body">
                <div className="v2-building">{item.building}</div>
                <div className="v2-serial">{item.serial}</div>
              </div>

              <div className="v2-card-footer">
                <div className="v2-metric">
                  <span className="v2-metric-label">Показания</span>
                  <span className="v2-metric-value">{item.reading} кВт·ч</span>
                </div>
                {item.consumption > 0 && (
                  <div className="v2-metric">
                    <span className="v2-metric-label">Ток</span>
                    <span className="v2-metric-value">
                      {item.consumption} А
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DemoUsersV2;
